// Copyright (c) 2025 Annadaneshwar Yadawad. All rights reserved.
import './Marketing.css';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PhoneIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 3h3.5l1.5 5-2 1.5a13 13 0 0 0 6 6L18 15l5 1.5V20a2 2 0 0 1-2 2A17 17 0 0 1 3 5a2 2 0 0 1 2-2Z"/>
  </svg>
);

const MailIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const PinIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 21s7-6.5 7-12a7 7 0 0 0-14 0c0 5.5 7 12 7 12Z"/>
    <circle cx="12" cy="9" r="2.5"/>
  </svg>
);

const Contact = () => (
  <>
    <Header />
    <div className="contact-page">
      <div className="contact-hero">
        <span className="contact-eyebrow">Contact</span>
        <h1 className="contact-title">Contact <span className="contact-highlight">team Servantica</span></h1>
        <p className="contact-lead">Questions about our notification services, CMS, or partnerships? Reach out to us directly — we'd love to hear from you.</p>
      </div>

      <div className="contact-grid">
        <div className="contact-card">
          <div className="cc-avatar">AY</div>
          <div className="cc-role">Founder &amp; Owner</div>
          <h3 className="cc-name">Annadaneshwar Yadawad <span style={{fontWeight: 400, opacity: 0.7}}>(aka Anand)</span></h3>
          <div className="cc-rows">
            <a className="cc-row" href="tel:+917259510747">
              <span className="cc-ic"><PhoneIcon /></span>
              <div><span className="cc-k">Phone</span><span className="cc-v">+91 72595 10747</span></div>
            </a>
            <div className="cc-row">
              <span className="cc-ic"><PinIcon /></span>
              <div><span className="cc-k">Address</span><span className="cc-v">At Post Khajjidoni, Bagalkot,<br />Karnataka, India – 587204</span></div>
            </div>
          </div>
          <a className="contact-call-btn" href="tel:+917259510747"><PhoneIcon /> Call now</a>
        </div>

        <div>
          <div className="contact-panel">
            <h3>Get in touch</h3>
            <p>Whether you need help with our notification platform, call management system, or have a partnership in mind, the team is happy to help. We typically respond within a couple of business days.</p>
          </div>
          <div className="contact-ways">
            <a className="contact-way" href="mailto:annadaneshwaryadawad1998@gmail.com">
              <div className="cw-icon cw-mail"><MailIcon /></div>
              <div className="cw-text">
                <span className="cw-label">Email us</span>
                <span className="cw-val">annadaneshwaryadawad1998@gmail.com</span>
              </div>
            </a>
            <a className="contact-way" href="tel:+917259510747">
              <div className="cw-icon cw-phone"><PhoneIcon /></div>
              <div className="cw-text">
                <span className="cw-label">Call us</span>
                <span className="cw-val">+91 72595 10747</span>
              </div>
            </a>
            <div className="contact-way">
              <div className="cw-icon cw-loc"><PinIcon /></div>
              <div className="cw-text">
                <span className="cw-label">Visit us</span>
                <span className="cw-val">Bagalkot, Karnataka, India</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </>
);

export default Contact;
